import { create } from "zustand";
import { devtools } from "zustand/middleware";

type ImageLike = File | Blob | string | null; 

export interface ProfileStore {
  image: ImageLike;
  imageCropFinished: boolean;
  imageResult: ImageLike;
  imageName: string;
  placeAutocomplete: unknown | null;
  countryState: string;
  countryCity: string;
  countryZipcode: string;
  aptOrSuite: string;
  editFullName: boolean;
  editPhone: boolean;
  editAddress: boolean;

  setImage: (v: ImageLike) => void;
  setImageCropFinished: (v: boolean) => void;
  setImageResult: (v: ImageLike) => void;
  setImageName: (v: string) => void;
  setPlaceAutocomplete: (v: unknown | null) => void;
  setCountryState: (v: string) => void;
  setCountryCity: (v: string) => void;
  setCountryZipcode: (v: string) => void;
  setAptOrSuite: (v: string) => void;
  setEditFullName: (v: boolean) => void;
  setEditPhone: (v: boolean) => void;
  setEditAddress: (v: boolean) => void;
  reset: () => void;
}

const initialState: Omit<
  ProfileStore,
  | "setImage"
  | "setImageCropFinished"
  | "setImageResult"
  | "setImageName"
  | "setPlaceAutocomplete"
  | "setCountryState"
  | "setCountryCity"
  | "setCountryZipcode"
  | "setAptOrSuite"
  | "setEditFullName"
  | "setEditPhone"
  | "setEditAddress"
  | "reset"
> = {
  image: null,
  imageCropFinished: false,
  imageResult: null,
  imageName: "",
  placeAutocomplete: null,
  countryState: "",
  countryCity: "",
  countryZipcode: "",
  aptOrSuite: "",
  editFullName: false,
  editPhone: false,
  editAddress: false,
};

export const useProfileStore = create<ProfileStore>()(
  devtools((set) => ({
    ...initialState,

    setImage: (v) => set({ image: v }),
    setImageCropFinished: (v) => set({ imageCropFinished: v }),
    setImageResult: (v) => set({ imageResult: v }),
    setImageName: (v) => set({ imageName: v }),
    setPlaceAutocomplete: (v) => set({ placeAutocomplete: v }),
    setCountryState: (v) => set({ countryState: v }),
    setCountryCity: (v) => set({ countryCity: v }),
    setCountryZipcode: (v) => set({ countryZipcode: v }),
    setAptOrSuite: (v) => set({ aptOrSuite: v }),
    setEditFullName: (v) => set({ editFullName: v }),
    setEditPhone: (v) => set({ editPhone: v }),
    setEditAddress: (v) => set({ editAddress: v }),

    reset: () => set({ ...initialState }),
  }))
);
